module.exports = "/_next/static/images/3781a0792e67d9c1a198f34976dc6d51-press-media-desktop.jpg";